import { GlobalWrapperModel } from './models';

export const SET_MODAL = 'global/SET_MODAL';
export type SET_MODAL = typeof SET_MODAL;

export type GlobalActions = {
  type: SET_MODAL;
  payload: GlobalWrapperModel;
};
